var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var handleResponse = function (res) { return __awaiter(void 0, void 0, void 0, function () {
    var error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!res.ok) {
                    throw new Error("API HTTP error! URL: ".concat(res.url, ", status: ").concat(res.status, ", message: ").concat(res.statusText));
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, res.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_1 = _a.sent();
                throw new Error("API Parsing Error. Error parsing response as JSON. URL: ".concat(res.url, ", status: ").concat(res.status, ", error: ").concat(error_1));
            case 4: return [2 /*return*/];
        }
    });
}); };
export var addItemToCartRequest = function (skuId, quantity) {
    var endpoint = "/marketplace/api/cart/items?skuId=".concat(skuId, "&quantity=").concat(quantity, "&language=").concat(window.currentLang);
    var onSiteAttribution = window.onSiteAttribution;
    if (onSiteAttribution)
        endpoint += "&source=".concat(onSiteAttribution);
    return fetch(endpoint, {
        method: "POST",
    }).then(handleResponse);
};
export var buyNowRequest = function (skuId, quantity) {
    var endpoint = "/marketplace/api/cart/items/buy-now?skuId=".concat(skuId, "&language=").concat(window.currentLang, "&quantity=").concat(quantity);
    var onSiteAttribution = window.onSiteAttribution;
    if (onSiteAttribution)
        endpoint += "&source=".concat(onSiteAttribution);
    return fetch(endpoint, {
        method: "POST",
    }).then(handleResponse);
};
export var removeItemFromCartRequest = function (skuId, quantity) {
    return fetch("/marketplace/api/cart/items/remove/".concat(skuId, "?quantity=").concat(quantity, "&language=").concat(window.currentLang), {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
    }).then(handleResponse);
};
export var updateCartItemQuantityRequest = function (skuId, quantity) {
    return fetch("/marketplace/api/cart/items/".concat(skuId, "?quantity=").concat(quantity, "&language=").concat(window.currentLang), {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
    }).then(handleResponse);
};
export var getSearchRecommendations = function (query) { return __awaiter(void 0, void 0, void 0, function () {
    var controller, signal, timeout, timeoutId;
    return __generator(this, function (_a) {
        controller = new AbortController();
        signal = controller.signal;
        timeout = 5000;
        timeoutId = setTimeout(function () { return controller.abort(); }, timeout);
        return [2 /*return*/, fetch("/marketplace/search/recommendations?query=".concat(encodeURIComponent(query), "&language=").concat(window.currentLang), { signal: signal })
                .then(function (res) {
                clearTimeout(timeoutId);
                return res;
            })
                .then(handleResponse)];
    });
}); };
export var getSafetyAttributes = function (skuId, language) {
    return fetch("/marketplace/api/sku/".concat(skuId, "/safety-attributes/").concat(window.currentCountry, "/").concat(language)).then(handleResponse);
};
export var getTranslatedSafetyAttributes = function (productId, skuId) {
    return fetch("/marketplace/api/translation/skuSafetyAttributes/".concat(productId, "/").concat(skuId, "?language=").concat(window.currentLang)).then(handleResponse);
};
export var getGeoIPProductData = function (productId, skuId) {
    return fetch("/marketplace/api/geoip/search/product/p-".concat(productId, "-").concat(skuId, "}")).then(handleResponse);
};
export var getHomepageHeroData = function (commaSeparatedHeroSizes, commaSeparatedImageFormats) {
    var endpoint = "/marketplace/api/home/hero?language=".concat(window.currentLang, "&sizes=").concat(commaSeparatedHeroSizes, "&formats=").concat(commaSeparatedImageFormats);
    return new Promise(function (resolve, reject) {
        if (!cmsDataExistsForCurrentLanguage(endpoint)) {
            fetch(endpoint)
                .then(handleResponse)
                .then(function (homeCmsData) {
                sessionStorage.setItem("CMS_".concat(window.currentLang, ":").concat(endpoint), JSON.stringify(homeCmsData));
                resolve(homeCmsData);
            })
                .catch(function (error) {
                reject(error);
            });
        }
        else {
            var sessionData = sessionStorage.getItem("CMS_".concat(window.currentLang, ":").concat(endpoint));
            if (sessionData) {
                var homeCmsData = JSON.parse(sessionData);
                resolve(homeCmsData);
            }
        }
    });
};
export var getPromotionalTilesData = function (commaSeparatedCmsImageSizes, commaSeparatedImageFormats) {
    var endpoint = "/marketplace/api/home/promo?language=".concat(window.currentLang, "&sizes=").concat(commaSeparatedCmsImageSizes, "&formats=").concat(commaSeparatedImageFormats);
    return new Promise(function (resolve, reject) {
        if (!cmsDataExistsForCurrentLanguage(endpoint)) {
            fetch(endpoint)
                .then(handleResponse)
                .then(function (promotionalTilesData) {
                sessionStorage.setItem("CMS_".concat(window.currentLang, ":").concat(endpoint), JSON.stringify(promotionalTilesData));
                resolve(promotionalTilesData);
            })
                .catch(function (error) {
                reject(error);
            });
        }
        else {
            var sessionData = sessionStorage.getItem("CMS_".concat(window.currentLang, ":").concat(endpoint));
            if (sessionData) {
                var promotionalTilesData = JSON.parse(sessionData);
                resolve(promotionalTilesData);
            }
        }
    });
};
function cmsDataExistsForCurrentLanguage(endpoint) {
    return !!sessionStorage.getItem("CMS_".concat(window.currentLang, ":").concat(endpoint));
}
